export const cleanPhoneNumber = (phone: string | null | undefined): string => {
    if (!phone) return '';
    return phone.replace(/[^\d+]/g, '');
};

export const formatPhoneNumber = (phone: string | null | undefined): string => {
    if (!phone) return '';
    
    const cleaned = cleanPhoneNumber(phone);
    if (!cleaned) return '';
    
    if (cleaned.startsWith('+')) {
        const countryCode = cleaned.slice(0, 3);
        const rest = cleaned.slice(3);
        const groups = rest.match(/.{1,2}/g) || [];
        return `${countryCode} ${groups.join(' ')}`;
    }
    
    const groups = cleaned.match(/.{1,2}/g) || [];
    return groups.join(' ');
};

export const isValidFrenchPhone = (phone: string | null | undefined): boolean => {
    if (!phone) return false;
    const cleaned = cleanPhoneNumber(phone);
    const frenchRegex = /^0[1-9]\d{8}$/;
    const internationalRegex = /^\+33[1-9]\d{8}$/;
    return frenchRegex.test(cleaned) || internationalRegex.test(cleaned);
};

export const formatPhoneInput = (value: string): string => {
    const cleaned = cleanPhoneNumber(value);
    const maxLength = cleaned.startsWith('+') ? 12 : 10;
    const limited = cleaned.slice(0, maxLength);
    return formatPhoneNumber(limited);
};
